import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";
import RevalidateRequest from "../../magData/Hotel/RevalidateRequest";
import RevalidateResponse from "../../magData/Hotel/RevalidateResponse";

function HotelRevalidatePage(props) {
  return (
    <>
      <Container fluid>
        <Row>
          <Col sm={12}>
            <p className="page-title">Hotel Revalidate Method</p>
          </Col>
          <Col sm={12}>
            <p>
              EndPoint : https://gdscpapi.parsgds.com/gateway/Hotel/revalidate
            </p>
          </Col>
          <Col sm={12}>
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <p>Body Parameters</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>gdsRefrenceID</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Request Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(RevalidateRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12}>
            <p>Response Information</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>PricedItineraries</td>
                  <td>
                    <p>Hotel Itineraries</p>
                  </td>
                  <td>Object</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>FareSourceCode</td>
                          <td> Itinerary Identifier</td>
                          <td>string</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>gdsRefrenceID</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>providerCategory</td>
                          <td>providerCategory</td>
                          <td>string</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>providerOwner</td>
                          <td>providerOwner</td>
                          <td>string</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>offer</td>
                          <td>offer</td>
                          <td>string</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>NonRefundable</td>
                          <td>NonRefundable</td>
                          <td>boolean</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>NonRefundable</td>
                          <td>NonRefundable</td>
                          <td>boolean</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>nationalityId</td>
                          <td>nationalityId</td>
                          <td>string</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>cityCode</td>
                          <td>cityCode</td>
                          <td>integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>Hotel</td>
                          <td>Hotel</td>
                          <td></td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>HotelId</td>
                                  <td>HotelID</td>
                                  <td>integer</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>lastUpdate</td>
                                  <td>lastUpdate</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Name</td>
                                  <td>Name</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>rating</td>
                                  <td>rating</td>
                                  <td>integer</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>reviewScore</td>
                                  <td>reviewScore</td>
                                  <td>integer</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>address</td>
                                  <td>address</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>email</td>
                                  <td>email</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>latitude</td>
                                  <td>latitude</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>
                                <tr>
                                  <td>longitude</td>
                                  <td>longitude</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>accommodation</td>
                                  <td>accommodation</td>
                                  <td>integer</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>accommodationName</td>
                                  <td>accommodationName</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>url</td>
                                  <td>url</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>phone</td>
                                  <td>phone</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>fax</td>
                                  <td>fax</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>description</td>
                                  <td>description</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>instructions</td>
                                  <td>instructions</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>beginTime</td>
                                  <td>beginTime</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>endTime</td>
                                  <td>endTime</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>checkOutTime</td>
                                  <td>checkOutTime</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>checkInTime</td>
                                  <td>checkInTime</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>mandatoryFee</td>
                                  <td>mandatoryFee</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>specialInstructions</td>
                                  <td>specialInstructions</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>minAge</td>
                                  <td>minAge</td>
                                  <td>integer</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>hotelImage</td>
                                  <td>hotelImage</td>
                                  <td>String</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                                <tr>
                                  <td>Amenities</td>
                                  <td>Amenities</td>
                                  <td>Collection of string</td>
                                  <td>
                                    <Badge bg="warning" text="dark">
                                      None.
                                    </Badge>
                                  </td>
                                </tr>

                              </tbody>
                            </Table>
                          </td>
                        </tr>
                        <tr>
                          <td>HotelId</td>
                          <td>HotelID</td>
                          <td>integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>PaymentDeadline</td>
                          <td>Payment Deadline</td>
                          <td>date</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>currency</td>
                          <td>currency</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>availableRoom</td>
                          <td>availableRoom</td>
                          <td>integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>plainTextCancellationPolicy</td>
                          <td>plainTextCancellationPolicy</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>netRate</td>
                          <td>netRate</td>
                          <td>decimal number</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>Rooms</td>
                          <td>Rooms</td>
                          <td>Object</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>roomTypeID</td>
                                  <td>
                                    <p>roomTypeID</p>
                                  </td>
                                  <td>integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Name</td>
                                  <td>
                                    <p>Name</p>
                                  </td>
                                  <td>string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>AdultCount</td>
                                  <td>
                                    <p>Adult Count</p>
                                  </td>
                                  <td>integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>totalTax</td>
                                  <td>
                                    <p>totalTax</p>
                                  </td>
                                  <td>integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>ChildCount</td>
                                  <td>
                                    <p>Child Count</p>
                                  </td>
                                  <td>integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>ChildAges</td>
                                  <td>
                                    <p>Child Ages</p>
                                  </td>
                                  <td>Collection of string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>MealType</td>
                                  <td>
                                    <p>Meal Type</p>
                                  </td>
                                  <td>string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>SharingBedding</td>
                                  <td>
                                    <p>Sharing Bedding</p>
                                  </td>
                                  <td>boolean</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>BedGroups</td>
                                  <td>
                                    <p>Bed Groups</p>
                                  </td>
                                  <td>string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>NetRate</td>
                                  <td>
                                    <p>Net Rate</p>
                                  </td>
                                  <td>decimal number</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>rateplan</td>
                                  <td>
                                    <p>rateplan</p>
                                  </td>
                                  <td>decimal number</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                        <tr>
                          <td>CancellationPolicies</td>
                          <td>
                            <p>Cancellation Policies</p>
                          </td>
                          <td>Object</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>Amount</td>
                                  <td>
                                    <p>Amount</p>
                                  </td>
                                  <td>decimal number</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>FromDate</td>
                                  <td>
                                    <p>From Date</p>
                                  </td>
                                  <td>date</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                        <tr>
                          <td>Remarks</td>
                          <td>Remarks</td>
                          <td>Collection of string</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>images</td>
                          <td>images</td>
                          <td>Collection of string</td>
                          <Badge bg="warning" text="dark">
                            None.
                          </Badge>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>imageUrl</td>
                                  <td>
                                    imageUrl
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>thumbnailUrl</td>
                                  <td>
                                    thumbnailUrl
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                        <tr>
                          <td>CheckIn</td>
                          <td>Check In Date</td>
                          <td>date</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              Required
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>CheckOut</td>
                          <td>Check Out Date</td>
                          <td>date</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              Required
                            </Badge>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Response Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(RevalidateResponse, null, 2)}
            </pre>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default HotelRevalidatePage;
